import { Injectable } from '@angular/core';
import { ReceivableDomain } from './domain/receivable-domain';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ReceivableResponse } from './domain/receivable-response';
import { environment } from '../environments/environment';
import { OepaIopAuthLibService, OepaTokenService } from '@ohioepa/oepa-iop-auth-lib';
import { Account } from '@ohioepa/oepa-ebiz-lib';
import { PaymentService } from './payment.service';
import { ReceivableListResponse } from './domain/receivable-list-response';
import { OepaAnonymousTokenService } from '@ohioepa/oepa-anonymous-auth-lib';


@Injectable({
  providedIn: 'root'
})
export class ReceivableSearchService {
  private receivableList: ReceivableDomain[] = [];
  private totalBalanceDue: number = 0;
  private domainURL = environment.revenuesRootURL;
  private rootURL = '/revenue/receivable/';
  private account: Account | undefined;
  private authToken: string = '';
  private anonymousParams: any = {};

  constructor(private http: HttpClient, 
    private tokenService: OepaAnonymousTokenService,
    private authService: OepaIopAuthLibService,
    private paymentService: PaymentService) { 

    }

  public setAccount(account: Account | undefined) {
    this.account = account;
  }

  public retrieveReceivableByID(receivableId: number) : Observable<ReceivableResponse> {
    let url = this.rootURL + 'getReceivableById/' + receivableId;
    this.getTokenInfo();
      if (this.account && !this.paymentService.isTestAccount()) {
        url = url + '?userid=' + this.account.userID;
      }
      return this.http.get<ReceivableResponse>(this.domainURL + url, { 
        headers: { 'Authorization': 'Bearer ' + this.authToken },
        params: this.anonymousParams     
      });
  }

  public retrieveReceivableByTransactionID(transactionID: number) : Observable<ReceivableListResponse> {
    let url = this.rootURL + 'getReceivableByTransactionId/' + transactionID;
    this.getTokenInfo();
    if (this.account && !this.paymentService.isTestAccount()) {
      url = url + '?userid=' + this.account.userID;
    }
    return this.http.get<ReceivableListResponse>(this.domainURL + url, { 
      headers: { 'Authorization': 'Bearer ' + this.authToken },
      params: this.anonymousParams
    });
  }

  public getReceivableList(): ReceivableDomain[] {
    return this.receivableList;
  }

  public addReceivableToList(receivable: ReceivableDomain) {
    // Check if receivable already exists in the list
    const existingReceivable = this.receivableList.find(r => r.id === receivable.id);
    if (!existingReceivable) {
      this.receivableList.push(receivable);
    }
  }

  public removeReceivableFromList(receivable: ReceivableDomain) {
    this.receivableList = this.receivableList.filter(({ id }) => id !== receivable.id);
  }

  public clearReceivableList() {
    this.receivableList = [];
  }

  public getTotalBalanceDue() : number {
    this.totalBalanceDue = 0;
    if (this.receivableList && this.receivableList.length > 0) {
      this.receivableList.forEach(receivable => {
        this.totalBalanceDue += receivable.balanceDue;
      })
    }
    return this.totalBalanceDue;
  }

  public getReceivableTypeDesc() : string {
    let typeDesc = '';
    if (this.receivableList && this.receivableList.length > 0) {
      this.receivableList.forEach(receivable => {
        typeDesc = receivable.typeDesc;
      })
    }
    return typeDesc;
  }

  public getReceivableTypeCode() : string {
    let typeCode = '';
    if (this.receivableList && this.receivableList.length > 0) {
      this.receivableList.forEach(receivable => {
        typeCode = receivable.typeCode;
      })
    }
    return typeCode;
  }
/*
  private getAuthToken(url: string) : string {
    let token = '';
    if (this.account && this.account.userID && !this.paymentService.isTestAccount()){
      token = this.authService.getAccessToken();
    }else {
      this.loadAnonymousToken();
      token = this.tokenService.getAuthToken(url);
    }
    return token;
  }
*/

  private getTokenInfo() {
    if (this.account && this.account.userID && !this.paymentService.isTestAccount()){
      this.authToken = this.authService.getAccessToken();
      this.anonymousParams = {};
    } else {
      this.loadAnonymousToken();
    }
  }


  private loadAnonymousToken() {
    const tokenInfo = this.tokenService.getTokenInfo();
    this.authToken = tokenInfo.authToken;
    this.anonymousParams = { oepats: tokenInfo.timestamp, oepase: tokenInfo.seed };
  }
}
